import { useState } from "react";
import { useSnackbar } from 'notistack';
import { Paper, Grid } from "@mui/material";
import Header from "./Header";
import AssetFilter from "./AssetFilter";
import { getInsuranceOverviewReportApi } from "../apiService";
import { globalPostService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import { trackActivity } from "../../../utils/mixpanel";

const InsuranceOverviewReport = ({ pltConstants, dropDownLoader }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState({});
  const [reportData, setReportData] = useState({});
  const onFieldChange = (key, value) => {
    setReportData((prev) => {
      const updatedData = { ...prev, [key]: value };
      return updatedData;
    });
  };
  const onFocusChange = (keyParam) => { setError(prev => ({ ...prev, [keyParam]: '' })) }
  const onExportReport = (extention) => {
    const payload = { file_type: extention, ...(reportData?.asset_type_id?.length && { asset_types: reportData.asset_type_id, }), }
    let validationInputs = {};
    validationInputs = {
      asset_type_id: reportData?.asset_type_id?.length > 0 ? "" : "Please select Asset",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true)
      globalPostService(getInsuranceOverviewReportApi(), payload)
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            setError({});
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Insurance Overview Report`, success_msg: response?.data?.message, payload: payload, response: response?.data })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Insurance Overview Report`, error_msg: response?.data?.message, payload: payload, response: response?.data })
          }
        })
    } else {
      setError(validationInputs)
      trackActivity('Item Export', { page_title: `Insurance Overview Report`, error_msg: validationInputs })
    }
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container spacing={1} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Insurance Overview Report" description="Summary of Insurance Coverage Across Fleet. Includes Policy Details, Coverage Periods, Insured Values, Providers and Expiry Alerts for Aircraft and Engines." />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 12, xs: 12 }}>
            <AssetFilter isRequired={true} error={error} pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} />
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default InsuranceOverviewReport